import { render } from "./EmailTypePicker.vue?vue&type=template&id=5b7e4ad9&scoped=true"
import script from "./EmailTypePicker.vue?vue&type=script&lang=js"
export * from "./EmailTypePicker.vue?vue&type=script&lang=js"

import "./EmailTypePicker.vue?vue&type=style&index=0&id=5b7e4ad9&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7e4ad9"]])

export default __exports__